import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { PsychologistRequestDetail } from '../../shared/models/request-psychologist-detail.model';
import { FHService } from 'npx-family-happy-common';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-request-psychologist-detail',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './request-psychologist-detail.component.html',
  styleUrl: './request-psychologist-detail.component.scss',
})
export class RequestPsychologistDetailComponent implements OnInit, OnDestroy {
  @Input() inputData!: PsychologistRequestDetail;
  @Input() requestID!: number;
  @Input() provincia!: string;
  @Input() reqService!: FHService;
  @Output() dataUpdated = new EventEmitter<PsychologistRequestDetail>();

  form!: FormGroup;

  private unsubscribe = new Subject<void>();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      hoursAmount: [0, [Validators.required, Validators.min(0)]],
      psychologistSpecialty: ['', Validators.required],
      trial: [false],
      serviceStart: [''],
      serviceDuration: [''],
      psychologistId: [''],
      requiredLanguageByte: this.fb.group({
        italian: [false],
        english: [false],
      }),
      requiredLanguage: this.fb.group({
        italian: [false],
        english: [false],
      }),
      requestDescription: [''],
      netHourCost: [0, [Validators.min(0)]],
      packageFlatCost: [0, [Validators.min(0)]],
    });

    this.initForm(this.inputData);
    this.form.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe((_) => {
      this.pushDataChanges();
    });
  }

  initForm(requestDetail: PsychologistRequestDetail) {
    if (!requestDetail) {
      return;
    }
    this.form.patchValue({
      ...requestDetail,
      requiredLanguage: {
        italian: this.inputData.requiredLanguage
          ? this.inputData.requiredLanguage.includes('IT')
          : false,
        english: this.inputData.requiredLanguage
          ? this.inputData.requiredLanguage.includes('EN')
          : false,
      },
    });
  }

  private pushDataChanges() {
    const data = this.form.value;
    console.log(data);
    let requiredLanguage: string[] = [];
    Object.entries<boolean>(data.requiredLanguage).forEach((value) => {
      if (value[1]) {
        let langValue = value[0] === 'italian' ? 'IT' : 'EN';
        requiredLanguage.push(langValue);
      }
    });
    const newPsychologistInfo: PsychologistRequestDetail = {
      ...data,
      survey: this.inputData.survey,
      requiredLanguage: requiredLanguage,
      requiredLanguageByte: [],
    };
    this.dataUpdated.emit(newPsychologistInfo);
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
